<template>
  <v-container fluid class="payroll-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            v-if="initvalue.payrollstatus!=='Complete'" 
            :href="`#tab-payroll`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document-multiple</v-icon>
            Payroll
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-files`">
            <v-icon class="mr-3">mdi-file-multiple</v-icon>
            Files
          </v-tab>
          <v-tab-item
            v-if="initvalue.payrollstatus!=='Complete'" 
            :value="'tab-payroll'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Payroll</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'payrollname')"
                        v-bind:value="initvalue.payrollname"
                        placeholder="Payroll Name"
                        persistent-hint
                        single-line hint="Enter the payroll name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=payrollstatus
                        :value="initvalue.payrollstatus"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'payrollstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the payroll status">
                      </v-select>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payroll/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPayroll()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <FileEditView :id="initvalue._id" :route="`payroll`" :files="files" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import FileEditView from "@/pages/File/Components/FileEditView.vue";

export default {
  components: {
    FileEditView
  },
  data () {
    return {
      payroll: {},
      payrollstatus: ['New', 'Pending', 'Complete'],
      files: [],
      initvalue: {},
    }
  },
  computed: {
    ...mapState('Payroll', ['isReceiving'])
  },
  methods: {
    ...mapActions('Payroll', ['updatePayrollRequest','getPayrollsRequest']),
    async editPayroll() {
      this.payroll._id = this.initvalue._id;
      this.updatePayrollRequest(this.payroll);
      this.getPayrollsRequest();
      router.push('/payroll/list');
    },
    updateChangedValue(value, field){
      this.payroll[field] = value;
    },
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'PayrollList' });
    this.files = await this.getPayrollFiles(this.initvalue._id);
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
